<mat-dialog-content>
  <mat-spinner [diameter]="50"></mat-spinner>
  <span>{{ message }}</span>
</mat-dialog-content>
